import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { SubscriptionDetail } from '@/types/subscriptions/subscription';
import { pages, formatRoute } from '@/settings/pages';
import { SharedButton } from '@/components/shared/Button';

type Props = {
  subscription: SubscriptionDetail;
};

export const EditBtn: React.FC<Props> = ({ subscription }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const path = pages.subscription.edit;
  const params: { requestCode: string } = {
    requestCode: subscription.requestCode,
  };

  const onClick = () => navigate(formatRoute(path, params));

  return (
    <SharedButton
      dataTest="do-edit"
      disabled={!subscription.isUpdatable}
      onClick={onClick}
      type="submit"
      fontSize="small"
    >
      {t('ui.action.changeOrder')}
    </SharedButton>
  );
};
